import React from 'react'
import Lottie from 'react-lottie-player'
import { motion } from 'framer-motion'
import loadingAnimationData from './../images/lottie/loading-linkone.json'

const LoadingAnimation = ({ title }: { title?: string }): JSX.Element => {
  return (
    <div className={'flex flex-col items-center gap-2'}>
      <motion.div
        initial={{ scale: 1, maxWidth: 100, maxHeight: 100, opacity: 1 }}
        exit={{ opacity: 0 }}>
        <Lottie animationData={loadingAnimationData} loop={true} play={true} />
      </motion.div>
      {title && (
        <div className={'font-Spartan font-bold text-blue-primary text-xl'}>{title}</div>
      )}
    </div>
  )
}

export default LoadingAnimation
